// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".term-form--layout form {\n  display: flex;\n  flex-direction: column;\n  gap: 10px; }\n\n.term-form--layout .term-form--actions {\n  display: grid;\n  width: 100%;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 10px;\n  align-items: center; }\n", ""]);
// Exports
module.exports = exports;
